import dayjs from 'dayjs'
import { isNil, mergeWith } from 'lodash'

export const secondsToMinutesAndSeconds = (seconds: number): string => {
  if (seconds < 0) return '--:--'
  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = Math.floor(seconds % 60)

  const minutesStr = minutes.toString().padStart(2, '0')
  const secondsStr = remainingSeconds.toString().padStart(2, '0')

  return `${minutesStr}:${secondsStr}`
}
export function getFileName(url: string) {
  try {
    const parsedUrl = new URL(url)
    const pathParts = parsedUrl.pathname.split('/')
    if (!pathParts.length) return ''
    return decodeURIComponent(pathParts[pathParts.length - 1])
  } catch {
    return ''
  }
}

export function getFileExtension(url: string) {
  const fileUrl = url.split('?')[0]
  const fileExtension = fileUrl?.split('.').pop()
  return fileExtension
}

export const proxySourcePath = (path: string) => {
  if (path?.startsWith('http://58.48.42.209')) {
    return path.replace(
      /^http(s)?:\/\/[^/]+/,
      import.meta.env.VITE_APP_COMMON_BASE_URL,
    )
  }
  return path
}

export function mergeObjects(oldObj: any, newObj: any) {
  return mergeWith(oldObj, newObj, (oldVal, newVal) => {
    if (isNil(newVal) || newVal === '') {
      return oldVal
    }
  })
}

export const downloadFile = (fileUrl: string, filename?: string) => {
  const fileName = filename || getFileName(fileUrl) || ''
  fetch(fileUrl)
    .then(response => response.blob())
    .then(blob => {
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = fileName
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    })
    .catch(error => {
      console.error('Error downloading file:', error)
    })
}

export function groupByKey(arr: any[], key: string) {
  return arr.reduce((result, item) => {
    const existingGroup = result.find((group: any) => group[key] === item[key])

    if (existingGroup) {
      existingGroup.list.push(item)
    } else {
      result.push({ [key]: key, list: [item] })
    }

    return result
  }, [])
}

export function dataURLtoFile(dataurl: string, fileName: string) {
  const arr = dataurl.split(',') as any
  const mime = arr[0].match(/:(.*?);/)[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], fileName, {
    type: mime,
  })
}

// 获取历史记录
export function formatterHistory(
  historys: Array<{
    obj: string
    value: string
    toolObj: any
    msgQueen: any
    loading?: any
    avatar?: any
    chat_id: any
  }>,
) {
  return historys.map(item => {
    if (item?.toolObj) {
      let { toolObj, msgQueen, avatar, chat_id, loading, ...rest } = item
      return {
        ...rest,
        value: [
          {
            type: 'text',
            text: {
              content: item.value,
            },
          },
          {
            type: 'tool',
            tools: [
              {
                ...item.toolObj,
              },
            ],
          },
        ],
      }
    } else {
      let { msgQueen, avatar, chat_id, loading, ...rest } = item

      return {
        ...rest,
        value: [
          {
            type: 'text',
            text: {
              content: item.value,
            },
          },
        ],
      }
    }
  })
}

export function getOrigin() {
  return import.meta.env.VITE_APP_COMMON_BASE_URL || import.meta.env.DEV
    ? 'https://chat-taichu-web-test.wair.ac.cn'
    : window.location.origin
}

export function getOriginPath() {
  return import.meta.env.DEV
    ? 'https://chat-taichu-web-test.wair.ac.cn'
    : window.location.origin
}

export function copyRichText(content: any) {
  const selection = window.getSelection()
  const range = document.createRange()

  range.selectNodeContents(content)
  selection?.removeAllRanges()
  selection?.addRange(range)

  try {
    document.execCommand('copy')
    selection?.removeAllRanges()
    console.log('复制成功')
    return true
  } catch (e) {
    console.log('复制失败', e)
    return false
  }
}
export function calculateExpirationTimestamp(days: number) {
  return dayjs().add(days, 'day').format('YYYY-MM-DD HH:mm:ss')
}

export function addTimestamp(date: any, daysToAdd: number) {
  return dayjs(date).add(daysToAdd, 'day').format('YYYY-MM-DD HH:mm:ss')
}
